import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreateComponent } from './create/create.component';
import { SelectorComponent } from './selector/selector.component';
import { MatSelectModule } from '@angular/material/select';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
@NgModule({
  declarations: [CreateComponent, SelectorComponent],
  imports: [CommonModule, MatSelectModule, ReactiveFormsModule, MatInputModule, MatButtonModule],
  exports: [CreateComponent, SelectorComponent]
})
export class EshopModule {}
